import { useCallback } from 'react';

import useAppDispatch from 'js/hooks/useAppDispatch';
import {
  invalidateCapsuleListTags,
  useCreateCluster,
  useUpdateCapsule,
  useDeleteCapsule,
} from 'new/stores/capsules/capsules.api';
import { setCapsules } from 'new/stores/capsules/capsule.slice';
import type {
  CreateClusterPayload,
  UpdateCapsuleArg,
} from 'new/stores/capsules/capsules.endpoints';

interface CapsulesAdapterHookReturn {
  clearCapsules: () => void;
  createCluster: (payload: CreateClusterPayload) => Promise<any>;
  isCreating: boolean;
  updateCapsule: (arg: UpdateCapsuleArg) => Promise<any>;
  isUpdating: boolean;
  deleteCapsule: (id: string) => Promise<any>;
  isDeleting: boolean;
}

export default function useCapsulesAdapter(): CapsulesAdapterHookReturn {
  const dispatch = useAppDispatch();
  const { createCluster, isLoading: isCreating } = useCreateCluster();
  const { updateCapsule, isLoading: isUpdating } = useUpdateCapsule();
  const { deleteCapsule, isLoading: isDeleting } = useDeleteCapsule();

  const clearCapsules = useCallback(() => {
    dispatch(invalidateCapsuleListTags());
    dispatch(setCapsules({ byId: [], entities: {} }));
  }, [dispatch]);

  return {
    clearCapsules,
    createCluster,
    isCreating,
    updateCapsule,
    isUpdating,
    deleteCapsule,
    isDeleting,
  };
}

export { useCapsulesAdapter };
